import { Component, OnInit } from '@angular/core';




@Component({
  selector: 'cm-pending-report-edit',
  templateUrl: './pending-report-edit.component.html',
  styleUrls: ['./pending-report-edit.component.css']
})
export class PendingReportEditComponent implements OnInit {



  constructor() { }

  ngOnInit() {
   
    //this.get_pending_report();

  }

  


}
